import GD from '../GD'
import { DCCAPI } from '../utils'

class HTTP {
  private dccapi: DCCAPI = new DCCAPI()
  private url = ''
  private authKey = 'web'

  constructor() {
    this.dccapi.debug = true
    this.dccapi.log = (txt) => GD.LOG.invoke(txt)
    this.init()
  }

  private init(): void {
    GD.AUTH_COMPLETE.subscribe(async (prof) => {
      this.authKey = prof.key
    })

    GD.REQ_HTTP.listener = async (req) => {
      if (!this.url || this.url.indexOf('http') === -1) {
        this.url = window.DCC_CONFIG.API_BASE_URL!
      }

      return this.dccapi.call({
        url: req.url || this.url,
        encrypt: req.encrypt === undefined ? true : req.encrypt,
        request: {
          ...req,
          key: this.authKey,
        },
      })
    }

    GD.SERVICE_READY.invoke('http')
  }
}
export default HTTP
